import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiStatDTO,
  StatDTO,
} from "@lib/strapi/dtos/components/shared/stat.dto";

export class StatService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiStatDTO,
  ): Promise<StatDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new StatDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.value = strapiData.value;
    dto.label = strapiData.label;
    return dto;
  }
}
